import React, { Component, createRef } from 'react';
import { withRouter } from "react-router-dom";
import { Modal, Row, Col } from "react-bootstrap";
import * as Cookies from "js-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import storage from "../../../Storage";
import socket from "../../../Socket";
import { Event, wait, decode, encode, randomString, RECAPTCHA } from "../../../Helper";
import C from "../../../Constant";
import Forget from "./Forget"; // Added missing import

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            forgetPage: false,
            resetPage: false,
            username: '',
            password: '',
            recaptcha: false,
            status: false,
            submitted: false,
            disabled: false,
            effect: 'zoomIn',
            reg_path: storage.getKey('isLogin') ? storage.getKey('isLogin') : null,
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.recaptchaRef = createRef();
    }

    componentWillMount() {
        this.setState({ code: storage.getKey('ref_code') });
        this.checkLoggingCode();


        if (window.location.pathname === '/login') {
            // storage.setKey('isLogin', true);
            // this.props.history.push('/');
        }
    }

    componentDidMount() {
        socket.on(C.LOGIN_USER, data => this.setLogin(decode(data)));

        if (this.props.justModal) {
            this.setState({ show: true });
        }

        this.checkRoute();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.checkRoute();
        }
    }

    checkRoute() {
        if (this.props.location.pathname === '/login') {
            if (!this.state.show) {
                this.handleShow();
            }
        }
    }

    checkLoggingCode() {
        let isReg = storage.getKey('isLogin');
        if (isReg === 'true') {
            this.handleShow();
        }
    }

    setLogin = (data) => {
        if (data.status === true) {
            this.setState({ status: "Successfully Login, Please Wait..." });
            Cookies.remove("session");
            Cookies.set("session", data.token, { expires: 14 });
            storage.setKey('token', data.token);

            // FAKES
            storage.setKey('user_token', randomString(50));
            storage.setKey('jwt_token', randomString(50));
            storage.setKey('secret_user', randomString(44));
            storage.setKey('secret_realtime', randomString(50));
            storage.setKey('security_key', randomString(10));
            storage.setKey('token_key', randomString(64));
            storage.setKey('secret_token', randomString(64));

            // REALS
            storage.setKey('name', data.name);
            storage.setKey('avatar', data.avatar);
            storage.setKey('email', data.email);
            storage.setKey('credit', data.credit?.kshs ?? data.credit ?? 0);
            storage.setKey('room', data.room);
            storage.setKey('friends', data.friends);
            storage.setKey('referral_code', data.referral_code);

            this.setState({ show: false, effect: 'zoomOut' });

            socket.emit(C.ONLINE, encode({
                jwt_token: storage.getKey('jwt_token'),
                user_token: storage.getKey('user_token'),
                security_key: storage.getKey('security_key'),
                secret_user: storage.getKey('secret_user'),
                secret_realtime: storage.getKey('secret_realtime'),
                client_system: storage.getKey('client_system'),
                token_key: storage.getKey('token_key'),
                secret_token: storage.getKey('secret_token'),
                token: data.token,
            }));

            // Set refresh flag for Index page
            // localStorage.setItem('shouldRefresh', 'true');
            this.props.history.push('/');

            wait(500).then(() => {
                window.location.reload(); // Trigger single refresh
            });
        } else {
            this.setState({ status: data.status, submitted: false, disabled: false });
        }
    };

    handleShow(e) {
        this.setState({ show: true, effect: 'zoomIn' });
    }

    handleClose() {
        this.setState({ show: false, effect: 'zoomOut', disabled: false, status: false, submitted: false });
        Event.emit('showAuthModal', false);
        if (this.props.location.pathname === '/login') {
            this.props.history.push('/');
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ submitted: true, disabled: true, status: this.props.t('please_wait') });

        const { username, password } = this.state;

        if (!(username && password)) {
            this.setState({ disabled: false, status: false });
            return;
        }

        wait(1000).then(() => {
            socket.emit(C.LOGIN_USER, encode({
                username: username,
                password: password,
                recaptcha: 'google'
            }));
        });
    }

    forgetPass = () => {
        this.setState({ forgetPage: !this.state.forgetPage });
    };

    resetPass = () => {
        this.setState({ resetPage: !this.state.forgetPage });
    };

    recaptchaChange = (value) => {
        this.setState({ recaptcha: value });
    };

    render() {
        let { justModal, t } = this.props;
        return (
            <>
                {!justModal &&
                    <button className='login-btn' onClick={this.handleShow}>
                        {t('login')}
                    </button>
                }
                <Modal
                    size="md"
                    centered={true}
                    show={this.state.show}
                    onHide={this.handleClose}
                    aria-labelledby="login-md-modal"
                    className={'auth-modal-custom animated ' + this.state.effect}
                >
                    <Modal.Header>
                        <img src="/assets/images/FASTA_FX.png" className={'auth-logo-large'} alt="Logo" />
                        <div className='auth-welcome-text'>
                            Welcome Back
                        </div>
                        <button type="button" className="close" onClick={this.handleClose}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <div className="auth-form-container">
                            {!this.state.forgetPage &&
                                <div>
                                    <form className="auth-form" onSubmit={this.handleSubmit}>
                                        <div className="auth-input-wrapper">
                                            <i className="mdi mdi-cellphone" />
                                            <input
                                                type="text"
                                                className="form-control auth-input-custom"
                                                placeholder="Mobile Number"
                                                value={this.state.username}
                                                autoComplete="off"
                                                onChange={e => this.setState({ username: e.target.value })}
                                            />
                                            {this.state.submitted && !this.state.username &&
                                                <div className="help-block text-white small mt-1 ml-2">Mobile Number is required</div>
                                            }
                                        </div>

                                        <div className="auth-input-wrapper">
                                            <i className="mdi mdi-lock-outline" />
                                            <input
                                                type="password"
                                                className="form-control auth-input-custom"
                                                placeholder="Password"
                                                value={this.state.password}
                                                autoComplete="off"
                                                onChange={e => this.setState({ password: e.target.value })}
                                            />
                                            {this.state.submitted && !this.state.password &&
                                                <div className="help-block text-white small mt-1 ml-2">Password is required</div>
                                            }
                                        </div>

                                        <button className="auth-btn-primary mt-2" disabled={this.state.disabled}>
                                            {this.state.disabled ? (
                                                <><i className="mdi mdi-loading mdi-spin mr-2" /> Signing In...</>
                                            ) : (
                                                'Sign In'
                                            )}
                                        </button>
                                    </form>

                                    <div className="text-center mt-3">
                                        <a href={'#'} onClick={this.forgetPass} className="auth-footer-link">
                                            <i className="mdi mdi-help-circle-outline" />
                                            Forgot your password?
                                        </a>
                                    </div>

                                    {this.state.status &&
                                        <div className={'auth-status-alert'}>
                                            {this.state.status}
                                        </div>
                                    }
                                </div>
                            }
                            {this.state.forgetPage &&
                                <Forget t={t} clicked={this.forgetPass} />
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

export default withRouter(Login);